const mockRewardData = {
  data: {
    customerReward: [
      {
        id: 44217,
        customerId: 6843375,
        campaignId: 80,
        rewardId: 507,
        reason: {
          customerId: 6843375,
          storeId: '309',
          campaignId: 80,
          uid: '',
          nthCustomerOfDay: 11,
          newAccount: false,
          firstScanOfDay: true,
          customerSegments: [
            {
              id: 26,
              uid: '4803259278415582',
              name: 'popup_audience_is_not_ec_nor_nc',
              customerId: 499675,
            },
          ],
          campaign: {
            id: 80,
            storeIds: ['309', '357'],
            uid: 'd04a4eg4m2ms73drda10',
            name: 'Games Golden ticket [DO NOT EDIT]',
            validFrom: '2025-04-01T08:00:00+08:00',
            validTill: '2035-04-30T08:00:00+08:00',
            status: 'ENABLED',
            owners: ['boning.he@ntucenterprise.sg'],
            createdAt: '2025-08-23T16:18:02.404746+08:00',
            updatedAt: '2025-11-07T10:51:25.774736+08:00',
          },
          rule: {
            id: 196,
            segmentId: null,
            campaignId: 80,
            weight: 1,
            type: 1,
            policy: {
              sequences: null,
              periods: null,
              dailyLimit: 0,
              firstEverScan: false,
            },
            interval: 0,
            createdAt: '2025-08-23T16:18:02.404746+08:00',
            updatedAt: '2025-04-23T16:18:02.404746+08:00',
            rewards: [
              {
                id: 507,
                ruleId: 196,
                type: 1,
                rewardType: 'OFFER',
                rewardValue: '13083916',
                validityPolicy: {
                  type: 'SAME_DAY',
                  cutOffTime: '00:00',
                  durationInHours: 0,
                  durationInDays: 0,
                },
                percentage: 10000,
              },
            ],
          },
          reward: {
            id: 507,
            ruleId: 196,
            type: 1,
            rewardType: 'OFFER',
            rewardValue: '13083916',
            validityPolicy: {
              type: 'SAME_DAY',
              cutOffTime: '00:00',
              durationInHours: 0,
              durationInDays: 0,
            },
            percentage: 10000,
          },
        },
        issuedAt: '2026-01-21T11:45:35.381572+08:00',
        createdAt: '2026-01-21T11:45:35.381838+08:00',
        updatedAt: '2026-01-21T11:45:35.381838+08:00',
      },
    ],
    count: 6,
    limit: 20,
    offset: 0,
  },
}

export default mockRewardData
